import { logEvent, setUserId, getAnalytics } from "firebase/analytics";
import { AppPlatform, AnalyticsEventType } from "app/types";

/**
 * ネイティブの Firebase に渡すか。Amazon 版のアプリはネイティブの Firebase が使えないので、
 * WebView の中でも Web の Firebase で送る
 */
export const usesNativeAnalytics = () =>
  !!window.ReactNativeWebView && window.parentsAppPlatform !== AppPlatform.Amazon;

const withPage = (params?: object) => ({
  ...params,
  page_path: location.pathname,
  page_title: location.pathname,
});

/**
 * イベントを GA に送る。アプリ（WebView）ではネイティブの Firebase に渡す（Amazon 版を除く）。
 * React の外からも呼べるように、hook にしていない。
 */
export const recordEvent = (type: AnalyticsEventType | string, params?: object) => {
  try {
    if (usesNativeAnalytics()) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ command: "logEvent", data: { event: type, params: withPage(params) } }),
      );
    } else {
      logEvent(getAnalytics(), type, withPage(params));
    }
  } catch (error) {
    console.warn("recordEvent error:", error);
  }
};

/** GA のユーザー ID（Web の Firebase で送るときだけ。ブラウザ・Amazon 版。ネイティブには受け取る Command がない） */
export const setAnalyticsUserId = (uid: string) => {
  try {
    if (!usesNativeAnalytics()) {
      setUserId(getAnalytics(), uid);
    }
  } catch (error) {
    console.warn("setAnalyticsUserId error:", error);
  }
};
